import React, { useEffect, useState } from 'react';
import SearchSelect from "../ui-components/SearchSelect";
import Button from "../ui-components/Button";
import {FormattedMessage} from "react-intl";
import Label from "../ui-components/Label";

const DEFAULT_OUTPUT_OBJ = {
  kcolor_question: null,
  surface_questions: [],
  label_question: null,
};

const ServiceConfiguratorBlockCalculationKColorGenerator = ({
  kColorValue,
  updateKColor,
  setSelectedOperator,
  questions,
}) => {

  const getOption = (id) => {
    const q = questions.find((q) => q.id === id);
    if (!q) return undefined;
    return {label: q.name, value: id}
  }

  const kcolorObject = kColorValue === "kcolor" ? { ...DEFAULT_OUTPUT_OBJ, original: kColorValue } : JSON.parse(kColorValue);
  const [selectedKColorQuestion, setSelectedKColorQuestion] = useState(getOption(kcolorObject.kcolor_question));
  const [selectedSurfaceQuestion, setSelectedSurfaceQuestion] = useState(kcolorObject.surface_questions?.map(getOption).filter(Boolean) ?? []);
  const [selectedLabelQuestion, setSelectedLabelQuestion] = useState(getOption(kcolorObject.label_question));

  useEffect(() => {
    updateKColor(kcolorObject);
  }, []);

  return (
    <div className="flex flex-col w-full mb-8 mt-8">
      <div className=" mb-2 flex text-center justify-center">
        <p className="font-bold">
          KCOLOR OPTIMIZATION GENERATOR
        </p>
      </div>
      {[
        {
          label: <FormattedMessage id="kcolor_question" defaultMessage="KColor question" />,
          value: selectedKColorQuestion,
          selectableQuestions: questions?.filter((q) => q.input_type === "k_color_input"),
          onChange: (e) => {
            setSelectedKColorQuestion(e);
            updateKColor({...kcolorObject, kcolor_question: e?.value});
          },
        },
        {
          label: <FormattedMessage id="surface_questions" defaultMessage="Surface questions" />,
          description: (
            <FormattedMessage
              id="surface_questions_description"
              defaultMessage="These questions will not be used in the optimization, but are necessary for other parts that require surface data retrieval (e.g. tintometers section). Select one or more questions: their values will be summed"
            />
          ),
          value: selectedSurfaceQuestion,
          selectableQuestions: questions?.filter((q) => q.input_type === "number_input"),
          onChange: (selected) => {
            setSelectedSurfaceQuestion(selected ?? []);
            updateKColor({...kcolorObject, surface_questions: selected?.map((v) => v.value) ?? []});
          },
          multi: true,
        },
        {
          label: <FormattedMessage id="label_question" defaultMessage="Label question" />,
          description: (
            <FormattedMessage
              id="label_question_description"
              defaultMessage="(OPTIONAL) This question will be used to label the configuration. Can be useful for tintometers configurations."
            />
          ),
          value: selectedLabelQuestion,
          selectableQuestions: questions?.filter((q) => q.input_type === "text_input"),
          onChange: (e) => {
            setSelectedLabelQuestion(e);
            updateKColor({...kcolorObject, label_question: e?.value});
          },
        },
      ].map(({label, description, selectableQuestions, value, onChange, multi}, key) => (
        <React.Fragment key={key}>
          <Label>{label}</Label>
          {description && <p className="text-xs text-gray-500 my-1">{description}</p>}
          <SearchSelect
            options={selectableQuestions?.map((q) => ({label: q.name, value: q.id})) ?? []}
            {...{value, onChange}}
            isClearable
            isMulti={!!multi}
          />
        </React.Fragment>
      ))}
      <div className="mt-4 flex justify-end">
        <Button onClick={() => setSelectedOperator(null)}>DONE</Button>
      </div>
    </div>
  );
}

export default ServiceConfiguratorBlockCalculationKColorGenerator;